import groupBy from 'lodash/groupBy';
import xorBy from 'lodash/xorBy';
import { NO_GROUP } from './consts';

export const filterSelectedOptions = (options, values) => {
  const filteredOptions = xorBy(values, options, 'value');
  return filteredOptions;
};

export const addGroupsToOptions = options => {
  const groupedOptionsByGroupName = groupBy(options, 'groupName');
  return Object.entries(groupedOptionsByGroupName).flatMap(
    ([groupName, groupItems]) =>
      groupName !== 'undefined'
        ? [
            {
              value: groupName,
              label: groupName,
              groupName,
              isGroup: true,
              items: groupItems
            },
            ...groupItems
          ]
        : groupItems
  );
};

export const groupifyOptions = options => {
  const groupedOptionsByGroupName = groupBy(
    options,
    item => item.groupName || NO_GROUP
  );

  let itemsWithoutGroup = [];
  // in case there're items without a group we saves it aside in a different variable
  if (groupedOptionsByGroupName[NO_GROUP]) {
    itemsWithoutGroup = groupedOptionsByGroupName[NO_GROUP];
    delete groupedOptionsByGroupName[NO_GROUP];
  }

  const arrayOfGroups = Object.entries(groupedOptionsByGroupName).map(
    ([groupName, items]) => {
      return {
        items,
        isGroup: true,
        groupName,
        value: groupName,
        label: groupName
      };
    }
  );

  return [arrayOfGroups, itemsWithoutGroup];
};

export function getLastFocusableIndex(focusableOptions, navigationElements) {
  const lastFocusableItem = focusableOptions[focusableOptions.length - 1];

  const lastFocusableIndex = navigationElements.findIndex(
    o => o.item.value === lastFocusableItem.value
  );
  return lastFocusableIndex;
}

export function getFirstFocusableIndex(focusableOptions, navigationElements) {
  const [firstFocusableElement] = focusableOptions;
  const firstFocusableIndex = navigationElements.findIndex(
    ({ item }) => item.value === firstFocusableElement.value
  );
  return firstFocusableIndex;
}
